// extracted by mini-css-extract-plugin
module.exports = {"tabs":"SubscriptionWrapper-module__tabs___20of_"};